import PopupBasic from 'src/game/components/popups/PopupBasic';
import View from '@play-co/timestep-core/lib/ui/View';
import i18n from 'src/lib/i18n/i18n';
import uiConfig from 'src/lib/ui/config';
import { FlexBoxView } from '@play-co/timestep-core/flexbox';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import { Feature } from 'src/replicant/analytics';
import { ImageScaleView, ImageView } from '@play-co/timestep-core/ui';
import sounds from 'src/lib/sounds';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';

import { AssetGroup } from '@play-co/timestep-core';

export default class PopupInviteURLCopied extends PopupBasic {
  private url: LangBitmapFontTextView;

  constructor(opts: { superview: View; close: VoidFunction }) {
    super({
      superview: opts.superview,
      close: () => opts.close(),
      zIndex: 10000,
      width: 558,
      height: 489,
      darkerBg: false,
      tracking: { feature: 'popup', $subFeature: 'popup-invite-url' },
    });

    this.buttonClose.removeFromSuperview();

    this.message.updateOpts({
      size: 30,
      width: 423,
      height: 166,
      x: this.box.style.width / 2,
      y: 275,
      centerOnOrigin: true,
    });

    const field = new ImageScaleView({
      superview: this.box,
      width: 472,
      height: 64,
      y: 145,
      x: this.box.style.width / 2,
      centerOnOrigin: true,
      image: 'assets/ui/shared/frames/quantity_textfield.png',
      scaleMethod: '3slice',
      sourceSlices: {
        horizontal: { left: 50, right: 50 },
      },
    });

    new ImageView({
      superview: field,
      image: 'assets/ui/friends/ico_link_light.png',
      width: 42,
      height: 42,
      x: 32,
      y: field.style.height / 2,
      centerOnOrigin: true,
    });

    this.url = new LangBitmapFontTextView({
      superview: field,
      width: 390,
      height: field.style.height,
      x: 252,
      y: field.style.height / 2,
      centerOnOrigin: true,
      align: 'left',
      verticalAlign: 'center',
      size: 30,
      font: 'Body',
      localeText: () => `https://play.c/invite-link`,
    });

    const copiedFrame = new ImageView({
      superview: field,
      image: 'assets/ui/friends/white_frame.png',
      width: 151,
      height: 61,
      x: field.style.width - 75,
      y: field.style.height / 2,
      centerOnOrigin: true,
    });

    new LangBitmapFontTextView({
      superview: copiedFrame,
      width: copiedFrame.style.width,
      height: copiedFrame.style.height,
      x: copiedFrame.style.width / 2,
      y: copiedFrame.style.height / 2,
      centerOnOrigin: true,
      align: 'center',
      verticalAlign: 'center',
      size: 30,
      font: 'Body',
      color: '#B37235',
      localeText: () => i18n('social.invite.referral.copied'),
    });

    const buttonsContainer = new FlexBoxView({
      superview: this.box,
      width: this.box.style.width - 40,
      height: 100,
      flex: {
        flexDirection: 'row',
        justifyContent: 'space-around',
      },
      x: 20,
      y: this.box.style.height - 120,
    });

    new ButtonScaleViewWithText({
      superview: buttonsContainer,
      ...uiConfig.buttons.secondary,
      fontSize: 40,
      width: 228,
      height: 95,
      font: 'Body',
      localeText: () => i18n('basic.ok'),
      tracking: {
        feature: Feature.INVITE._,
        $subFeature: Feature.INVITE.INVITE_OK,
      },
      onClick: async () => {
        sounds.sfx.play('ok');
        return opts.close();
      },
    });
  }

  protected getAssetsGroup() {
    return new AssetGroup([
      'assets/ui/shared/frames/quantity_textfield.png',
      'assets/ui/friends/ico_link_light.png',
      'assets/ui/friends/white_frame.png',
    ]);
  }

  public init({
    url,
    title,
    message,
  }: {
    url: string;
    title: string;
    message: string;
  }) {
    super.init({
      title,
      message,
    });

    this.url.updateOpts({ localeText: () => url });
  }
}
